import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  createDoctorSchedule,
  editDoctorSchedule,
  showDoctorSchedule,
} from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { RegisterProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';
import Timeline from '~/components/Timeline';

class DoctorSchedule extends React.Component {
  render () {
    return (
      <RegisterProvider>
        <Switch>
          <Route
            exact
            path={createDoctorSchedule.spec}
            render={(props) => (
              <>
                <Can I="new" a="Schedules">
                  {() => <New {...props} />}
                </Can>
                <Can not I="new" a="Schedules">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
          <Route
            exact
            path={editDoctorSchedule.spec}
            render={(props) => (
              <>
                <Can I="edit" a="Schedules">
                  {() => <Edit {...props} />}
                </Can>
                <Can not I="edit" a="Schedules">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
          <Route
            exact
            path={showDoctorSchedule.spec}
            render={(props) => (
              <>
                <Can I="show" a="Schedules">
                  {() => <Show {...props} />}
                </Can>
                <Can not I="show" a="Schedules">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
          <Route
            render={(props) => (
              <>
                <Can I="show_calendar" a="Schedules">
                  {() => <Timeline {...props} />}
                </Can>
                <Can I="list" a="Schedules">
                  {() => <List {...props} />}
                </Can>
                <Can not I="list" a="Schedules">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
        </Switch>
      </RegisterProvider>
    );
  }
}

export default DoctorSchedule;
